import React, { useState } from "react";
import { db } from "../firebase";
import { ref, set } from "firebase/database";
import {
    FaPlus,
    FaRegTrashAlt,
    FaBold,
    FaItalic,
    FaStrikethrough,
    FaLink,
    FaImage,
    FaEraser
} from "react-icons/fa";
import { toast } from "react-toastify";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const AddProductForm = () => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState("");
    const [adminMessage, setAdminMessage] = useState("");
    const [images, setImages] = useState([{ type: "link", value: "" }]);
    const [isPreview, setIsPreview] = useState(false);
    const [isReady, setIsReady] = useState(true); // Status produk (ready atau not ready)

    // Fungsi untuk menambahkan produk ke database
    const handleSubmit = (e) => {
        e.preventDefault();

        const productId = "prod_" + Math.random().toString(36).substr(2, 9);
        const productRef = ref(db, `products/${productId}`);

        set(productRef, {
            id: productId,
            name,
            description,
            price,
            images,
            adminMessage,
            status: isReady // Tambahkan status produk
        })
            .then(() => {
                toast.success("Produk berhasil ditambahkan!");
                setName("");
                setDescription("");
                setPrice("");
                setAdminMessage("");
                setImages([{ type: "link", value: "" }]);
                setIsReady(true);
            })
            .catch((error) => {
                toast.error("Error menambahkan produk:", error);
            });
    };

    const addImageInput = () => {
        setImages([...images, { type: "link", value: "" }]);
    };

    const removeImage = (index) => {
        const updatedImages = images.filter((_, i) => i !== index);
        setImages(updatedImages);
    };

    const handleImageChange = (index, field, value) => {
        const updatedImages = [...images];
        updatedImages[index][field] = value;
        setImages(updatedImages);
    };

    const addMarkdown = (syntax) => {
        const textarea = document.getElementById("description");
        const cursorPos = textarea.selectionStart;
        const textBefore = textarea.value.substring(0, cursorPos);
        const textAfter = textarea.value.substring(cursorPos);
        const newText = textBefore + syntax + textAfter;

        setDescription(newText);
        setTimeout(() => {
            textarea.selectionStart = textarea.selectionEnd =
                cursorPos + syntax.length;
        }, 0);
    };

    const clearTextarea = () => {
        setDescription("");
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="p-6 bg-white shadow-md rounded-md"
        >
            <h2 className="text-2xl font-bold mb-4">Tambah Produk</h2>

            {/* Nama Produk */}
            <div className="mb-4">
                <label className="block text-gray-700">Nama Produk</label>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full p-3 border rounded-md"
                    required
                />
            </div>

            {/* Deskripsi Produk */}
            <div className="mb-4">
                <label className="block text-gray-700">Deskripsi</label>
                <div className="flex mb-2 gap-2">
                    <button
                        type="button"
                        onClick={() => addMarkdown("**bold**")}
                        className="p-2 rounded-md bg-gray-200"
                    >
                        <FaBold />
                    </button>
                    <button
                        type="button"
                        onClick={() => addMarkdown("_italic_")}
                        className="p-2 rounded-md bg-gray-200"
                    >
                        <FaItalic />
                    </button>
                    <button
                        type="button"
                        onClick={() => addMarkdown("~~strikethrough~~")}
                        className="p-2 rounded-md bg-gray-200"
                    >
                        <FaStrikethrough />
                    </button>
                    <button
                        type="button"
                        onClick={() => addMarkdown("[Link](url)")}
                        className="p-2 rounded-md bg-gray-200"
                    >
                        <FaLink />
                    </button>
                    <button
                        type="button"
                        onClick={() => addMarkdown("![Image](url)")}
                        className="p-2 rounded-md bg-gray-200"
                    >
                        <FaImage />
                    </button>
                    <button
                        type="button"
                        onClick={() => setIsPreview(false)}
                        className={`p-2 rounded-md ${
                            !isPreview
                                ? "bg-blue-500 text-white"
                                : "bg-gray-300"
                        }`}
                    >
                        Edit
                    </button>
                    <button
                        type="button"
                        onClick={() => setIsPreview(true)}
                        className={`p-2 rounded-md ${
                            isPreview ? "bg-blue-500 text-white" : "bg-gray-300"
                        }`}
                    >
                        Preview
                    </button>
                    <button
                        type="button"
                        onClick={clearTextarea}
                        className="p-2 rounded-md bg-red-500 text-white"
                    >
                        <FaEraser />
                    </button>
                </div>

                {isPreview ? (
                    <div className="w-full p-3 border rounded-md h-40 overflow-y-auto bg-gray-100">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {description || "_Tidak ada konten tersedia._"}
                        </ReactMarkdown>
                    </div>
                ) : (
                    <textarea
                        id="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        className="w-full p-3 border rounded-md h-40"
                        placeholder="Deskripsi menggunakan Markdown..."
                        required
                    />
                )}
            </div>

            {/* Harga Produk */}
            <div className="mb-4">
                <label className="block text-gray-700">Harga</label>
                <input
                    type="number"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    className="w-full p-3 border rounded-md"
                    required
                />
            </div>

            {/* Pesan Admin */}
            <div className="mb-4">
                <label className="block text-gray-700">Pesan Admin</label>
                <textarea
                    value={adminMessage}
                    onChange={(e) => setAdminMessage(e.target.value)}
                    className="w-full p-3 border rounded-md h-32"
                    placeholder="Tambahkan pesan khusus untuk produk..."
                />
            </div>

            {/* Foto Produk */}
            <div className="mb-4">
                <label className="block text-gray-700">Foto Produk</label>
                {images.map((image, index) => (
                    <div key={index} className="flex items-center mb-2">
                        <select
                            value={image.type}
                            onChange={(e) =>
                                handleImageChange(index, "type", e.target.value)
                            }
                            className="p-2 border rounded-md mr-2"
                        >
                            <option value="link">Link</option>
                            <option value="upload">Upload</option>
                        </select>

                        {image.type === "link" ? (
                            <input
                                type="text"
                                value={image.value}
                                onChange={(e) =>
                                    handleImageChange(
                                        index,
                                        "value",
                                        e.target.value
                                    )
                                }
                                placeholder="Masukkan URL gambar"
                                className="w-full p-2 border rounded-md"
                                required
                            />
                        ) : (
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file.size > 300 * 1024) {
                                        toast.error(
                                            "Ukuran file terlalu besar! Maksimum 300 KB."
                                        );
                                        return;
                                    }
                                    if (file) {
                                        const reader = new FileReader();
                                        reader.onload = (upload) => {
                                            handleImageChange(
                                                index,
                                                "value",
                                                upload.target.result
                                            );
                                        };
                                        reader.readAsDataURL(file);
                                    }
                                }}
                                className="w-full p-2 border rounded-md"
                                required
                            />
                        )}
                        {images.length > 1 && (
                            <button
                                type="button"
                                onClick={() => removeImage(index)}
                                className="ml-2 p-2 bg-red-500 text-white rounded-md"
                            >
                                <FaRegTrashAlt />
                            </button>
                        )}
                    </div>
                ))}
                <button
                    type="button"
                    onClick={addImageInput}
                    className="mt-2 p-2 bg-green-500 text-white rounded-md"
                >
                    <FaPlus />
                </button>
            </div>

            {/* Status Produk */}
            <div className="mb-4">
                <label className="block text-gray-700 mb-2">
                    Status Produk
                </label>
                <div className="flex items-center gap-4">
                    {/* Lingkaran Animasi */}
                    <span
                        className={`w-4 h-4 rounded-full ${
                            isReady
                                ? "animate-blink-green"
                                : "animate-blink-red"
                        }`}
                    ></span>

                    {/* Toggle Switch */}
                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={isReady}
                            onChange={() => setIsReady(!isReady)}
                        />
                        <span className="slider round"></span>
                    </label>
                </div>
            </div>

            {/* Tombol Submit */}
            <button
                type="submit"
                className="btn btn-primary w-full p-3 bg-blue-500 text-white rounded-md"
            >
                Tambah Produk
            </button>
        </form>
    );
};

export default AddProductForm;
